<template>
  <div>
    <v-textarea
      v-if="textArea"
      v-bind="$attrs"
      :append-icon="icon"
      :value="value"
      :class="getAppName()"
      @input="$emit('update:value', $event)"
    />
    <v-text-field
      v-else
      :class="getAppName()"
      dense
      v-bind="$attrs"
      :append-icon="icon"
      :value="value"
      @input="$emit('update:value', $event)"
    />
  </div>
</template>

<script>
import { appIdentifier } from "@/utils/appIdentifier.js";
export default {
  name: "BaseInput",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: ""
    },
    textArea: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  methods: {
    getAppName() {
      return appIdentifier();
    }
  }
};
</script>

<style lang="scss">
.v-input {
  border-radius: 12px !important;
  font-family: DINNextLTPro-Regular;

  input {
    color: #ffffff !important;
    padding-left: 8px;
    padding-right: 4px;
    color: $grey !important;
  }

  textarea {
    color: $grey !important;
  }

  input,
  textarea {
    color: $white !important;

    &::placeholder {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }

  .v-icon {
    color: white !important;
  }

  .v-input__control {
    .v-input__slot fieldset {
      border: 2px solid var(--v-secondary-base) !important;
    }
  }

  &.canals5D {
    input,
    textarea {
      caret-color: white;
    }

    .v-input__control {
      .v-input__slot fieldset {
        border: 2px solid #ffffff !important;
      }
    }

    .v-icon {
      color: $secondary-canals5D !important;
    }
  }

  &.huygens {
    input,
    textarea {
      caret-color: white;
    }

    .v-input__control {
      .v-input__slot fieldset {
        border: 2px solid #bebb9b !important;
        border-radius: 23px;
      }
    }

    .v-icon {
      color: #ffffff;
    }
  }

  .v-input__icon--append .v-icon {
    color: #ffffff;
  }
}
</style>
